
<template>
  <v-navigation-drawer app touchless temporary :stateless="dialog" v-model="timeDrawer" persistent right enable-resize-watcher mobile-breakpoint="10240" :width="$vuetify.breakpoint.width>450?450:$vuetify.breakpoint.width">
    <v-app-bar flat tile fixed color="transparent">
      <v-app-bar-nav-icon @click="closeTime">
        <v-icon>close</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon>
        <v-icon>mdi-clipboard-text-search</v-icon>
      </v-app-bar-nav-icon>
    </v-app-bar>
    <div v-if="this.loading" :style="`height:${$vuetify.breakpoint.height}px`">
      <v-container fill-height>
        <v-row justify="center">
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>

          </v-col>
        </v-row>
      </v-container>

    </div>
    <v-container pa-0 fill-height v-if="!this.loading">
      <fixed :job="job" :clocked-in="clockedIn" @close-time="closeTime()" :status="status" v-if="fixedJob"></fixed>
      <hourly :job="job" :clocked-in="clockedIn" @close-time="closeTime()" :status="status" :last-clock="lastClock" :can-complete="canComplete" :total-seconds-worked="totalSecondsWorked" :clear-interval="clearInterval" v-else></hourly>

    </v-container>
  </v-navigation-drawer>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import {
  object
} from 'rxfire/database'
import {
  map
} from 'rxjs/operators'
import Fixed from '@/components/obrero/timekeeping/Fixed.vue'
import Hourly from '@/components/obrero/timekeeping/Hourly.vue'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    Fixed,
    Hourly
  },
  props: [],
  data () {
    return {
      timeDrawer: false,
      index: 0,
      applicant: {},
      job: {},
      clearInterval: null,
      clockedIn: null,
      status: null,
      lastClock: null,
      canComplete: null,
      totalSecondsWorked: 0,
      loading: false,
      dialog: true
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'timeOpen', 'timeSelection']),
    fixedJob () {
      return this.job.rateType !== 'Hourly'
    }
  },
  mounted: function () {
  },
  destroyed () {
  },
  methods: {
    sendPaymentReminder () {
      var notification = {
        'notificationType': 'Payment Reminder',
        'notificationText': [`${this.userProfile.public.name} is requesting a payment for ${this.job.title}`],
        'notificationDate': new Date(),
        'jobId': this.job._key,
        'defaultTab': 'Payouts'
      }
      var updates = {}
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/paymentRequested`] = true
      fb.database.ref(`/user/${this.job.createdBy}/profile/notifications`).push(notification)
      fb.database.ref().update(updates)
      this.paymentReminderDialog = false
    },
    editTime () {
      this.thisLog.secondsWorked = parseFloat(this.thisLog.hours) * 3600
      this.thisLog.manualTime = true
      this.thisLog.shiftDate = this.shiftDate ? new Date(moment(this.shiftDate)) : new Date(moment())
      var updates = {}
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog/${this.thisLog._key}`] = this.thisLog
      fb.database.ref().update(updates)
      this.thisLog = {
        hours: 0,
        reason: ''
      }
      this.index3 = this.index3 + 1
      this.manualTimeDialog = false
    },
    startShiftFixed () {
      var updates = {}

      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = true
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Started'
      updates[`user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Started'

      fb.database.ref().update(updates)
      this.snackbar.message = this.$language.jobDetails['Shift Started']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    completeShiftFixed () {
      var newKey = fb.database.ref().child(`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog`).push().key
      var updates = {}
      var shift = {
        _key: newKey,
        logTitle: 'Shift Completed',
        shiftDate: new Date(),
        status: 'pending',
        expenses: this.job.applicants[this.currentUser.uid].expenses
      }
      var notification = {
        'notificationType': 'Shift Completed',
        'notificationText': [`${this.userProfile.public.name} completed a shift for ${this.job.title}`],
        'notificationDate': new Date(),
        'jobId': this.job._key,
        'defaultTab': 'Payouts'
      }
      updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = false
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/expenses`] = null
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Pending Payment'
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog/${newKey}`] = shift
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
      fb.database.ref().update(updates)
      this.snackbar.message = this.$language.jobDetails['Shift Complete']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    handleShiftStart () {
      this.clockIn()
      this.shiftStartDialog = false
    },

    handleShowExpensesPrompt () {
      this.showExpensesForm = true
      this.showExpensePrompt = false
      this.expensesSummary = ''
      this.expenses = 0
    },
    cancelExpenseForm () {
      this.showExpensesForm = false
      this.showExpensePrompt = true
      this.expensesSummary = ''
      this.expenses = 0
      this.completeDialog = false
    },
    updateTime () {
      if ((this.lastClock || []).state === 'in') {
        if ((((this.job || {}).applicants || {})[this.currentUser.uid] || {}).secondsWorked) {
          this.secondsWorked = moment(new Date()).diff(this.lastClock.date, 'seconds') + this.job.applicants[this.currentUser.uid].secondsWorked
        } else {
          this.secondsWorked = moment(new Date()).diff(this.lastClock.date, 'seconds')
        }
      } else if ((this.lastClock || []).state === 'out') {
        this.secondsWorked = this.job.applicants[this.currentUser.uid].secondsWorked
      }
    },
    async startJob () {
      this.buttonLoading = true
      fb.geoFireApp.set(this.job._key, null)
      var updates = {}
      var updatedDate = new Date()
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Started'
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Started'
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/updatedDate`] = updatedDate
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/startedOn`] = updatedDate
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/status`] = 'Started'

      var newKey = fb.database.ref().child(`jobs`).push().key
      var notification = {
        'notificationType': 'Job Started',
        'notificationText': `${this.userProfile.public.name} has CLOCKED IN for ${this.job.title}`,
        'notificationDate': updatedDate,
        'jobId': this.job._key,
        'defaultTab': 'Summary'
      }
      updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
      this.buttonLoading = false
      this.startDialog = false
      this.statusDialog = false
      this.snackbar.message = this.$language.jobDetails['You started this job.']
      this.snackbar.show = true
      this.index2 = this.index2 + 1
      await fb.database.ref().update(updates)
    },
    async completeJob () {
      if (!this.job.repeat) {
        this.buttonLoading = true
        fb.geoFireApp.set(this.job._key, null)
        var updates = {}
        var updatedDate = new Date()
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Pending Payment'
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/completedOn`] = updatedDate
        updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Pending Payment'
        updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/updatedDate`] = updatedDate
        // updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/status`] = 'Pending Payment'
        updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
        var newKey = fb.database.ref().child(`jobs`).push().key
        var notification = {
          'notificationType': 'Job Completed',
          'notificationText': ['Worker completed your job ', this.job.title],
          'notificationDate': updatedDate,
          'jobId': this.job._key,
          'defaultTab': 'Payouts'
        }
        updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
        await fb.database.ref().update(updates)
        this.buttonLoading = false
        this.completeDialog = false
        this.statusDialog = false
        this.showExpensesForm = false
        this.showExpensePrompt = true
        this.snackbar.message = this.$language.jobDetails['You completed this job.']
        this.snackbar.show = true
        this.index2 = this.index2 + 1
      } else {
        this.completeShiftFixed()
        this.completeDialog = false
        this.showExpensesForm = false
        this.showExpensePrompt = true
      }
    },
    closeTime () {
      this.$store.commit('setTimeOpen', false)
      this.applicant = {}
      this.job = {}
      this.applicantSub.unsubscribe()
      this.jobSub.unsubscribe()
      this.clearInterval = new Date()
    },
    scrollToEnd () {
      this.$nextTick(() => {
        var container = this.$el.querySelector('.chat-container')
        if (container !== null) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    formatName (val) {
      if (val === 'Hefe') {
        return 'Hefe'
      }
      var str = (val || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    }
  },
  watch: {

    timeOpen () {
      this.timeDrawer = this.timeOpen.open
    },
    timeSelection () {
      this.loading = true
      this.jobSub = object(fb.database.ref(`jobs/${this.timeSelection.jobId}/public`))
        .pipe(map(change => ({
          _key: change.snapshot.key,
          ...change.snapshot.val()
        })))
        .subscribe(job => {
          this.job = job
        })
      this.applicantSub = object(fb.database.ref(`jobs/${this.timeSelection.jobId}/applicants/${this.currentUser.uid}`))
        .pipe(map(change => ({
          _key: change.snapshot.key,
          ...change.snapshot.val()
        })))
        .subscribe(applicant => {
          if (Object.keys(applicant).length > 1) {
            this.job.applicants = {}
            this.job.applicants[this.currentUser.uid] = applicant
            this.status = applicant.status
            this.clockedIn = applicant.clockedIn
            this.canComplete = applicant.canComplete
            this.jobLog = applicant.jobLog
            if (((((this.job || {}).applicants || {})[this.currentUser.uid] || {}).clockLog || false)) {
              var last = Object.keys(this.job.applicants[this.currentUser.uid].clockLog).map(k => {
                return {
                  key: k,
                  state: this.job.applicants[this.currentUser.uid].clockLog[k].state,
                  date: this.job.applicants[this.currentUser.uid].clockLog[k].date
                }
              }).reduce((a, b) => {
                return new Date(a.date) > new Date(b.date) ? a : b
              })
              this.lastClock = last
            } else {
              this.lastClock = []
            }
            this.totalSecondsWorked = (((this.job || {}).applicants || {})[this.currentUser.uid] || {}).totalSecondsWorked || 0
            var shifts = Object.keys((((this.job || {}).applicants || {})[this.applicantId] || {}).jobLog || {})
              .map(k => {
                return ((((this.job || {}).applicants || {})[this.applicantId] || {}).jobLog || {})[k]
              }).filter(k => {
                return k.status === 'pending'
              })
            this.selectedShifts = shifts

            shifts = Object.keys((((this.job || {}).applicants || {})[this.currentUser.uid] || {}).jobLog || {})
              .map(k => {
                return ((((this.job || {}).applicants || {})[this.currentUser.uid] || {}).jobLog || {})[k]
              }).filter(k => {
                return k.status === 'pending'
              })
            this.hasPendingShifts = shifts.length > 0
          }
          this.loading = false
        })
    }

  },

  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHours (val) {
      if (!val) {
        return '-'
      }
      return parseFloat(val / 60 / 60).toFixed(2)
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatName (val) {
      if (val === 'Hefe') {
        return 'Hefe'
      }
      var str = (val || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    }
  }
}
</script>

<style >
.messages {
  flex-grow: 1;
  margin-bottom: 68px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
  background-color: #f2f2f2;
}
.spinner {
  margin: 0;
  width: 30px;
  text-align: center;
  color: green;
}

.spinner > div {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  background: rgb(53, 53, 53);
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
